const { duration } = require("moment")

document.addEventListener("turbolinks:load", function() {
    let to_export
    if(($("body").data("controller") == "home" || $("body").data("controller") == "calendar" ) && ($("body").data("user_role") == "manager" || $("body").data("user_role") == "admin" || ($("body").data("user_role") == "super_admin"))) {

 

        let table_all;
        let table_pending;
        let table_inprogress;
        let table_accepted;
        let table_client_rates;
        let table_canceled;
        let table_rejected;
        let table_completed;
        let table_rates;
        let modal_car2
        let date_starts
        let date_ends
        let pending_date_starts
        let pending_date_ends
        let accepted_date_starts
        let accepted_date_ends
        let inprogress_date_starts
        let inprogress_date_ends
        let completed_date_starts
        let completed_date_ends
        let canceled_date_starts
        let canceled_date_ends
        let rejected_date_starts
        let rejected_date_ends

        if (document.getElementById("modal-car") != null) {
            modal_car = new bootstrap.Modal(document.getElementById("modal-car"), {backdrop: 'static', keyboard: false});
        }

        if (document.getElementById("modal-car2") != null) {
            modal_car2 = new bootstrap.Modal(document.getElementById("modal-car2"), {backdrop: 'static', keyboard: false});
        }

        document.addEventListener("turbolinks:before-cache", function() {
            if (table_all != null)
                table_all.destroy();
            if (table_pending != null)
                table_pending.destroy();
            if (table_inprogress != null)
                table_inprogress.destroy();
            if (table_accepted != null)
                table_accepted.destroy();
            if (table_canceled != null)
                table_canceled.destroy();
            if (table_rejected != null)
                table_rejected.destroy();
            if (table_completed != null)
                table_completed.destroy();
            if (table_rates != null)
                table_rates.destroy();
            if (table_client_rates != null)
                table_client_rates.destroy();

        })

        var rater = require("rater-js");
        var myRater;
        let service_rater;
        let appointment_id;
        let service_id;
        let modal_new_car
     
        if ($("#new_km").length > 0) {
            $("#new_km").select2({
               tags: true,
                width: '100%',
                dropdownParent: $("#modal-new_appointment"),
            })
        }
        
        $("#new_km").on("select2:open", function() {
            document.querySelector(`.select2-search__field`).focus();
        })

        $("#new-appoint-phone").mask('(216) 99 999999');
        $("#new-appoint-second_phone").mask('(216) 99 999999');

        $("#calendar-services, #calendar-workshop").on("change", function() {
            let service_id = $("#calendar-services option:selected").val()
            let workshop_id = $("#calendar-workshop option:selected").val()
            window.location = "/calendar?service=" + service_id + "&workshop=" + workshop_id
        })
        
        if ($("#selected_service").val() != "")
            $("#calendar-services").val($("#selected_service").val())
        else 
            $("#calendar-services").val($("#calendar-services option:selected").val())

        if ($("#selected_service").val() != "")
            $("#calendar-workshop").val($("#selected_workshop").val())
        else 
            $("#calendar-workshop").val($("#calendar-workshop option:selected").val())

        $('#list_clients').select2({
            dropdownParent: $('#modal-new_appointment'),
            minimumResultsForSearch: '',
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: "Rechercher un client",
            ajax: {
                url: '/workers/search',
                dataType: 'json',
                cache: false,
                data: function (params) {
                    $(".select2-results__options").append("<img src='/assets/loader'>")
                    var query = {
                      search: params.term,
                      type: 'public',
                      date: $("#new-appoint-date").val(),
                      workshop_ids: $("#calendar-workshop").attr("data-workshops_id")
                    }
                    return query;
                },
                processResults: function (data, params) {
                    
                    params.page = params.page || 1;
                    return {
                        results: data.items,
                        pagination: {
                            more: (params.page * 30) < data.total_count
                        }
                    };
                }
            },
            cache: false,
            minimumInputLength: 2,
            templateResult: function (repo) {
                if (repo.loading) {
                    return repo.name;
                }
                
                var $container = $(
                    "<div class='select2-result-repository clearfix'>" +
                        "<div class='select2-result-repository__meta'>" +
                            "<div class='select2-result-repository__title'></div>" +
                        "</div>" +
                    "</div>"
                );
                
                $container.find(".select2-result-repository__title").text(repo.name);
                
                return $container;
            },
            templateSelection: function(repo) {
                if (repo != undefined) {
                    $("#new-appoint-full_name").val(repo.name)
                    $("#new-appoint-phone").val(repo.phone)
                    $("#new-appoint-phone").attr("data-phone", repo.phone)
                    $("#new-appoint-email").val(repo.email)
                    $("#new-appoint-matricule").html("")

                    if (repo.id != "") {
                        // check car dispnibility
                        fetch(`/workers/check-dispo-cars/${$("#new-appoint-date").val()}/${repo.id}`, {
                            method: 'GET',
                            mode: 'cors',
                            cache: 'default',
                        }).then(function(response) {
                            if (response.ok) {
                                response.json().then(function(data) {

                                    $("#new-appoint-service").html("")
                                    $("#new-appoint-workshop").trigger("change")
            
                                    $("#btn-new-car").removeClass("d-none")
                                    let workshop_ids = $("#new-appoint-workshop").attr("data-workshops_id").split(',')
                                    
                                    for(var i=0 ; i<repo.cars.length ; i++) {

                                        let disabled = ""
                                        if (data.find(({ car_id, date }) => car_id === repo.cars[i].id && $("#new-appoint-date").val() === date && data.state == ["accepted", "pending", "in_progress"])) {
                                            disabled = "disabled"
                                        }

                                        if ($(`#new-appoint-matricule option[value='${repo.cars[i].id}']`).length == 0) {
                
                                        $("#new-appoint-matricule").append(`
                                            <option data-km='${repo.cars[i].brand.km}' data-phone='${repo.cars[i].phone}' value='${repo.cars[i].id}' ${disabled} ${repo.cars_pending.includes(repo.cars[i].id) ? 'disabled' : ''}>${repo.cars[i].brand.brand} ${repo.cars[i].model.name} (${repo.cars[i].car_number})</option>
                                        `)
                                        }

                                        // $("#new_km").html('')
                                        // // km
                                        // for(var j=1 ; j<34 ; j++ ) {
                                        //     $("#new_km").append(`<option value='${j * repo.cars[i].brand.km}'>${j * repo.cars[i].brand.km}</option>`)
                                        // }

                                        
                                    }

                                $("#new-appoint-matricule").trigger("change")
                                })
                            }
                        })
                    }

                    // if (repo.cars != null ) {
                    //     for(var i=0 ; i<repo.cars.length ; i++) {
                    //         if ($(`#new-appoint-matricule option[value='${repo.cars[i].id}']`).length == 0) {
                               
                    //             if (repo.cars[i].active === true) {
                    //                 let disabled = ""
                    //                 if (repo.appointments.find(({ car_id, date }) => car_id === repo.cars[i].id && $("#new-appoint-date").val() === date)) {
                    //                     disabled = "disabled"
                    //                 }

                    //                 $("#new-appoint-matricule").append(`
                    //                     <option value='${repo.cars[i].id}' ${disabled} >${repo.cars[i].model} (${repo.cars[i].car_number})</option>
                    //                 `)
                    //             }
                    //         }
                    //     }
                    // }
                    
                    $("#new-appoint-client_id").val(repo.id)

                    // if (repo.name.includes("(no subscription)") || repo.name.includes("(expired)") || repo.name.includes("(canceled)")) {
                    //     $("#btn-save-booking").addClass("disabled")
                    //     $("#btn-save-booking").attr("disabled", true)
                    //     $(".error-member-state").html("<b>Unable to save because the member subscription is not active!</b>")
                    // }
                    // else {
                    //     $("#btn-save-booking").removeClass("disabled")
                    //     $("#btn-save-booking").attr("disabled", false)
                    //     $(".error-member-state").html("")
                    // }

                }
        
                return repo.name || repo.text;
                
            }
        })

        $(document).on("change", "#new-appoint-matricule", function() {
            let km = $("#new-appoint-matricule option:selected").attr("data-km")

            let car_id = $(this).val()
            let phone = $("#new-appoint-matricule option:selected").attr("data-phone")
          
            if (phone != "null") {
                $(".car-phone-container").removeClass("d-none")
                $("#new-appoint-car-phone").val(phone)
            }
            else {
                $(".car-phone-container").addClass("d-none")
                $("#new-appoint-car-phone").val("")
            }

            $("#new-appoint-workshop").attr("disabled", true)
            $(".loader-workshops").removeClass("d-none")

            if (km != undefined) {
                $("#new_km").html('')
                $("#new_km").append("<option selected disabled>km</option>")
                for(var j=1 ; j<34 ; j++ ) {
                    $("#new_km").append(`<option value='${j * km}'>${j * km}</option>`)
                }
            }
            
            if (car_id != null) {
                fetch(`/workshops/get-car-workshops/${car_id}`, {
                    method: 'GET',
                    mode: 'cors',
                    cache: 'default',
                }).then(function(response) {
                    response.json().then(function(data) {

                        $("#new-appoint-workshop").html('')

                        jQuery.each(data, function (i, val) {
                            $("#new-appoint-workshop").append(`<option value='${val.workshop.id}'>${val.workshop.name}</option>`)
                        })

                        $("#new-appoint-workshop").attr("disabled", false)
                        $(".loader-workshops").addClass("d-none")

                        $("#new-appoint-workshop").trigger("change")
                    })
                })
            }
        })

        $('#list_client_rates').select2({
            dropdownParent: $('#modal-see_rates'),
            minimumResultsForSearch: '',
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: "Rechercher un client",
            ajax: {
                url: '/workers/search',
                dataType: 'json',
                data: function (params) {
                    $(".select2-results__options").append("<img src='/assets/loader'>")
                    var query = {
                      search: params.term,
                      type: 'public'
                    }
                    return query;
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.items,
                        pagination: {
                            more: (params.page * 30) < data.total_count
                        }
                    };
                }
            },
            cache: true,
            minimumInputLength: 2,
            templateResult: function (repo) {
                if (repo.loading) {
                    return repo.name;
                }
                
                var $container = $(
                    "<div class='select2-result-repository clearfix'>" +
                        "<div class='select2-result-repository__meta'>" +
                            "<div class='select2-result-repository__title'></div>" +
                        "</div>" +
                    "</div>"
                );
                
                $container.find(".select2-result-repository__title").text(repo.name);
                
                return $container;
            },
            templateSelection: function(repo) {
                if (repo != undefined && service_id != undefined){
                    fetch(`/appointments/get-client-rates/${repo.id}/${service_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            table_client_rates.rows().clear().draw();
                            
                            jQuery.each(data, function (i, val) {
                                
                                let el = document.createElement('div')
                                el.setAttribute("id", `client_rating-${val.id}`)
                                
                                let client_rating = rater({element: el, rateCallback: function rateCallback(rating, done) {
                                    client_rating.setRating(rating);
                                    done();
                                }, 
                                    starSize:32,
                                    step: 0.5,
                                    rating: val.star,
                                });
                                client_rating.disable()

                                let newRow = table_client_rates.row.add([
                                    val.date,
                                    val.name,
                                    el.outerHTML,
                                    val.note
                                ] ).draw( false ).node();
            
                                $(newRow).attr("data-element_id", data.id);
                            });
                        })
        
                    });
                }
        
                return repo.name || repo.text;
            }
        })

        table_all = $('#table-all_appointments').DataTable({
            initComplete: function() {
                $("#table-all_appointments_filter").before(`<div style='display:inline'>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="all_appointments_clients" id="all_appointments_clients" checked>
                        <label class="form-check-label" for="all_appointments_clients" style="font-style: italic; font-size: 14px;">
                            Clients
                        </label>
                    </div>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="all_appointments_managers" id="all_appointments_managers" checked>
                        <label class="form-check-label" for="all_appointments_managers" style="font-style: italic; font-size: 14px;">
                            Managers
                        </label>
                    </div>
                    <div class="text-start" style='display:inline'>
                        <label class="form-check-label" for="all_appointments_date" style="font-style: italic; font-size: 14px;">
                            Date
                        </label>
                        <input type="text" id="all_appointments_date" class="form-control" style="width:250px; display:inline" autocomplete="off">
                        <a class="input-button" title="clear" data-clear>
                            <i class="fa fa-circle-xmark"></i>
                        </a>
                    </div>
                </div>`)

                $("#all_appointments_date").flatpickr({
                    mode: "range",
                    dateFormat: "d/m/Y",
                    allowInput: true,
                    autoClose: true,
                    locale: "fr",

                    onClose: function(selectedDates, dateStr, instance) {
                        date_starts = moment(new Date(document.querySelector('#all_appointments_date')._flatpickr.selectedDates[0])).format('YYYY-MM-DD')
                        date_ends = moment(new Date(document.querySelector('#all_appointments_date')._flatpickr.selectedDates[1])).format('YYYY-MM-DD')

                        if (date_starts != "Invalid date" && date_ends != "Invalid date")
                            table_all.ajax.reload()
                    },
                });

                $(".input-button").on("click", function() {
                    $("#all_appointments_date").val("")
                    date_starts = null
                    date_ends = null
                    table_all.ajax.reload()
                })

                $(document).on("click", "#all_appointments_clients, #all_appointments_managers", function() {
                    table_all.ajax.reload()
                })
                
                $(document).on("click", ".btn-edit-car2", function() {
                    $(".spinner-border").removeClass("d-none")

                    car_id = $(this).attr("data-car_id")
                    brand_id = $(this).attr("data-brand_id")
                    model_id = $(this).attr("data-model_id")
                    brand_name = $(this).attr("data-brand_name")
                    model_name = $(this).attr("data-model_name")
                    let car_number = $(this).attr("data-car_number")
                    let vin = $(this).attr("data-vin")
                    let phone = $(this).attr("data-phone")
                    let has_appointments = $(this).attr("data-has_appointments")

                    $("#car-model").attr("disabled", true)
                    
                    fetch(`/clients/brand-models/${brand_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            $(".spinner-border").addClass("d-none")

                            // $("#car-model").html("")
                            // $("#car-model").append("<option selected disabled>Selectionner le modèle</option>")
                            
                            // $("#car-model").attr("disabled", false)
                            
                            // jQuery.each(data, function (i, val) {
                            //     $("#car-model").append(`<option value='${val.id}'>${val.name}</option>`)
                            // });
        
                            // $("#car-brand").val(brand_id)
                            // $("#car-model").val(model_id)

                            $("#car-brand_name").val(brand_name)
                            $("#car-model_name").val(model_name)

                            if (has_appointments == "true") {
                                //$("#btn-save-car").addClass("d-none")
                                $("#car-brand").attr("disabled", true)
                                $("#car-model").attr("disabled", true)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                            else {
                                //$("#btn-save-car").removeClass("d-none")
                                $("#car-brand").attr("disabled", false)
                                $("#car-model").attr("disabled", false)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                        })
                    });


                    $("#car-car_number").val(car_number)
                    $("#car-vin").val(vin)
                    $("#car-phone").val(phone)
                    
                    modal_car2.show()
                })

            },
            responsive: true,
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-all_appointments').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-services option:selected").val()
                    e.workshop_id = $("#filter-workshops option:selected").val()
                    e.clients =  $("#all_appointments_clients").prop("checked")
                    e.managers =  $("#all_appointments_managers").prop("checked")
                    if (date_starts != null && date_starts != "" && date_starts != "Invalid date") {
                        e.date_starts = date_starts
                        e.date_ends = date_ends
                    }
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service"},
                {"data": "workshop"},
                {"data": "date",
                    "render": function(data, display, record) {
                        return `${data}<br>${record.time}`
                    }
                },
                {"data": "created_at", 
                    "render": function(data, display, record) {
                        return moment(new Date(data)).locale("fr").utc().format('DD/MM/YYYY H:m')
                    }
                },
                {"data": "user_name"},
                {"data": "car_number", 
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-edit-car2' data-brand_name='${record.brand_name}' data-model_name='${record.model_name}' data-car_number='${record.car_number}' data-vin='${record.vin}' data-phone='${record.car_phone}' data-car_id='${record.car_id}' data-brand_id='${record.brand_id}' data-model_id='${record.model_id}'>${data}</a>`
                    }
                },
                {"data": "state"},
                {"data": "source", 
                    "render": function(data, display, record) {
                        let source = record.source

                        if (record.source == "Manager")
                            return source += `<br><span style='font-size: 12px;'>${record.source_name}</span>`
                        else
                            return source
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-appointment' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ], 
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
                
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "columnDefs": [
                {
                    "width": '200px', targets: [0],
                    "width": '300px', targets: [1],
                    "width": '100px', targets: [2,3],
                    "width": '60px', targets: [5],
                }
            ],
            "bPaginate": true,
            "bFilter": true,
            "bInfo": true,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "pageLength": 10,
            "bAutoWidth": false,
            'order' : [[3,'desc']]
        });
        

        table_pending = $('#table-pending').DataTable({
            initComplete: function() {

                $("#table-pending_filter").before(`<div style='display:inline'>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="pending_clients" id="pending_clients" checked>
                        <label class="form-check-label" for="pending_clients" style="font-style: italic; font-size: 14px;">
                            Clients
                        </label>
                    </div>
                    <div class="text-start" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="pending_managers" id="pending_managers" checked>
                        <label class="form-check-label" for="pending_managers" style="font-style: italic; font-size: 14px;">
                            Managers
                        </label>
                    </div>
                </div>`)

                $(document).on("click", "#pending_clients, #pending_managers", function() {
                    table_pending.ajax.reload()
                })
                
                $(document).on("click", ".btn-edit-car2", function() {
                    $(".spinner-border").removeClass("d-none")

                    car_id = $(this).attr("data-car_id")
                    brand_id = $(this).attr("data-brand_id")
                    model_id = $(this).attr("data-model_id")
                    let car_number = $(this).attr("data-car_number")
                    let vin = $(this).attr("data-vin")
                    let phone = $(this).attr("data-phone")
                    let has_appointments = $(this).attr("data-has_appointments")

                    $("#car-model").attr("disabled", true)
                    
                    fetch(`/clients/brand-models/${brand_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            $(".spinner-border").addClass("d-none")

                            $("#car-model").html("")
                            $("#car-model").append("<option selected disabled>Selectionner le modèle</option>")
                            
                            $("#car-model").attr("disabled", false)
                            
                            jQuery.each(data, function (i, val) {
                                $("#car-model").append(`<option value='${val.id}'>${val.name}</option>`)
                            });
        
                            $("#car-brand").val(brand_id)
                            $("#car-model").val(model_id)


                            if (has_appointments == "true") {
                                //$("#btn-save-car").addClass("d-none")
                                $("#car-brand").attr("disabled", true)
                                $("#car-model").attr("disabled", true)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                            else {
                                //$("#btn-save-car").removeClass("d-none")
                                $("#car-brand").attr("disabled", false)
                                $("#car-model").attr("disabled", false)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                        })
                    });


                    $("#car-car_number").val(car_number)
                    $("#car-vin").val(vin)
                    $("#car-phone").val(phone)
                    
                    modal_car2.show()
                })
            },
            responsive: true,
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-pending').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-services option:selected").val()
                    e.workshop_id = $("#filter-workshops option:selected").val()
                    e.clients =  $("#pending_clients").prop("checked")
                    e.managers =  $("#pending_managers").prop("checked")
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service"},
                {"data": "workshop"},
                {"data": "date",
                    "render": function(data, display, record) {
                        return `${data}<br>${record.time}`
                    }
                },
                {"data": "created_at", 
                    "render": function(data, display, record) {
                        return moment(new Date(data)).locale("fr").utc().format('DD/MM/YYYY H:m')
                    }
                },
                {"data": "user_name"},
                {"data": "car_number", 
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-edit-car2' data-car_number='${record.car_number}' data-vin='${record.vin}' data-phone='${record.car_phone}' data-car_id='${record.car_id}' data-brand_id='${record.brand_id}' data-model_id='${record.model_id}'>${data}</a>`
                    }
                },
                {"data": "state"},
                {"data": "source", 
                    "render": function(data, display, record) {
                        let source = record.source

                        if (record.source == "Manager")
                            return source += `<br><span style='font-size: 12px;'>${record.source_name}</span>`
                        else
                            return source
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-appointment' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ],
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": true,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "pageLength": 10,
            "bAutoWidth": false,
            'order' : [[3,'desc']]
        });
        
        table_inprogress = $('#table-inprogress').DataTable({
            initComplete: function() {

                $("#table-inprogress_filter").before(`<div style='display:inline'>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="inprogress_clients" id="inprogress_clients" checked>
                        <label class="form-check-label" for="inprogress_clients" style="font-style: italic; font-size: 14px;">
                            Clients
                        </label>
                    </div>
                    <div class="text-start" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="inprogress_managers" id="inprogress_managers" checked>
                        <label class="form-check-label" for="inprogress_managers" style="font-style: italic; font-size: 14px;">
                            Managers
                        </label>
                    </div>
                </div>`)

                $(document).on("click", "#inprogress_clients, #inprogress_managers", function() {
                    table_inprogress.ajax.reload()
                })
              
                $(document).on("click", ".btn-edit-car2", function() {
                    $(".spinner-border").removeClass("d-none")

                    car_id = $(this).attr("data-car_id")
                    brand_id = $(this).attr("data-brand_id")
                    model_id = $(this).attr("data-model_id")
                    let car_number = $(this).attr("data-car_number")
                    let vin = $(this).attr("data-vin")
                    let phone = $(this).attr("data-phone")
                    let has_appointments = $(this).attr("data-has_appointments")

                    $("#car-model").attr("disabled", true)
                    
                    fetch(`/clients/brand-models/${brand_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            $(".spinner-border").addClass("d-none")

                            $("#car-model").html("")
                            $("#car-model").append("<option selected disabled>Selectionner le modèle</option>")
                            
                            $("#car-model").attr("disabled", false)
                            
                            jQuery.each(data, function (i, val) {
                                $("#car-model").append(`<option value='${val.id}'>${val.name}</option>`)
                            });
        
                            $("#car-brand").val(brand_id)
                            $("#car-model").val(model_id)


                            if (has_appointments == "true") {
                                //$("#btn-save-car").addClass("d-none")
                                $("#car-brand").attr("disabled", true)
                                $("#car-model").attr("disabled", true)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                            else {
                                //$("#btn-save-car").removeClass("d-none")
                                $("#car-brand").attr("disabled", false)
                                $("#car-model").attr("disabled", false)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                        })
                    });


                    $("#car-car_number").val(car_number)
                    $("#car-vin").val(vin)
                    $("#car-phone").val(phone)
                    
                    modal_car2.show()
                })

            },
            responsive: true,
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-inprogress').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-services option:selected").val()
                    e.workshop_id = $("#filter-workshops option:selected").val()
                    e.clients =  $("#inprogress_clients").prop("checked")
                    e.managers =  $("#inprogress_managers").prop("checked")
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service"},
                {"data": "workshop"},
                {"data": "date",
                    "render": function(data, display, record) {
                        return `${data}<br>${record.time}`
                    }
                },
                {"data": "created_at", 
                    "render": function(data, display, record) {
                        return moment(new Date(data)).locale("fr").utc().format('DD/MM/YYYY H:m')
                    }
                },
                {"data": "user_name"},
                {"data": "car_number", 
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-edit-car2' data-car_number='${record.car_number}' data-vin='${record.vin}' data-phone='${record.car_phone}' data-car_id='${record.car_id}' data-brand_id='${record.brand_id}' data-model_id='${record.model_id}'>${data}</a>`
                    }
                },
                {"data": "state"},
                {"data": "source", 
                    "render": function(data, display, record) {
                        let source = record.source

                        if (record.source == "Manager")
                            return source += `<br><span style='font-size: 12px;'>${record.source_name}</span>`
                        else
                            return source
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-appointment' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ],
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": true,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "pageLength": 10,
            "bAutoWidth": false,
            'order' : [[3,'desc']]
        });

        table_accepted = $('#table-accepted').DataTable({
            initComplete: function() {

                $("#table-accepted_filter").before(`<div style='display:inline'>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="accepted_clients" id="accepted_clients" checked>
                        <label class="form-check-label" for="accepted_clients" style="font-style: italic; font-size: 14px;">
                            Clients
                        </label>
                    </div>
                    <div class="text-start" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="accepted_managers" id="accepted_managers" checked>
                        <label class="form-check-label" for="accepted_managers" style="font-style: italic; font-size: 14px;">
                            Managers
                        </label>
                    </div>
                </div>`)

                $(document).on("click", "#accepted_clients, #accepted_managers", function() {
                    table_accepted.ajax.reload()
                })
              
                $(document).on("click", ".btn-edit-car2", function() {
                    $(".spinner-border").removeClass("d-none")

                    car_id = $(this).attr("data-car_id")
                    brand_id = $(this).attr("data-brand_id")
                    model_id = $(this).attr("data-model_id")
                    let car_number = $(this).attr("data-car_number")
                    let vin = $(this).attr("data-vin")
                    let phone = $(this).attr("data-phone")
                    let has_appointments = $(this).attr("data-has_appointments")

                    $("#car-model").attr("disabled", true)
                    
                    fetch(`/clients/brand-models/${brand_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            $(".spinner-border").addClass("d-none")

                            $("#car-model").html("")
                            $("#car-model").append("<option selected disabled>Selectionner le modèle</option>")
                            
                            $("#car-model").attr("disabled", false)
                            
                            jQuery.each(data, function (i, val) {
                                $("#car-model").append(`<option value='${val.id}'>${val.name}</option>`)
                            });
        
                            $("#car-brand").val(brand_id)
                            $("#car-model").val(model_id)


                            if (has_appointments == "true") {
                                //$("#btn-save-car").addClass("d-none")
                                $("#car-brand").attr("disabled", true)
                                $("#car-model").attr("disabled", true)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                            else {
                                //$("#btn-save-car").removeClass("d-none")
                                $("#car-brand").attr("disabled", false)
                                $("#car-model").attr("disabled", false)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                        })
                    });


                    $("#car-car_number").val(car_number)
                    $("#car-vin").val(vin)
                    $("#car-phone").val(phone)
                    
                    modal_car2.show()
                })
            },
            responsive: true,
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-accepted').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-services option:selected").val()
                    e.workshop_id = $("#filter-workshops option:selected").val()
                    e.clients =  $("#accepted_clients").prop("checked")
                    e.managers =  $("#accepted_managers").prop("checked")
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service"},
                {"data": "workshop"},
                {"data": "date",
                    "render": function(data, display, record) {
                        return `${data}<br>${record.time}`
                    }
                },
                {"data": "created_at", 
                    "render": function(data, display, record) {
                        return moment(new Date(data)).locale("fr").utc().format('DD/MM/YYYY H:m')
                    }
                },
                {"data": "user_name"},
                {"data": "car_number", 
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-edit-car2' data-car_number='${record.car_number}' data-vin='${record.vin}' data-phone='${record.car_phone}' data-car_id='${record.car_id}' data-brand_id='${record.brand_id}' data-model_id='${record.model_id}'>${data}</a>`
                    }
                },
                {"data": "state"},
                {"data": "source", 
                    "render": function(data, display, record) {
                        let source = record.source

                        if (record.source == "Manager")
                            return source += `<br><span style='font-size: 12px;'>${record.source_name}</span>`
                        else
                            return source
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-appointment' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ],
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": true,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "pageLength": 10,
            "bAutoWidth": false,
            'order' : [[3,'desc']]
        });

        table_completed = $('#table-completed').DataTable({
            initComplete: function() {
                $(document).on("click", ".btn-edit-car2", function() {
                    $(".spinner-border").removeClass("d-none")

                    car_id = $(this).attr("data-car_id")
                    brand_id = $(this).attr("data-brand_id")
                    model_id = $(this).attr("data-model_id")
                    let car_number = $(this).attr("data-car_number")
                    let vin = $(this).attr("data-vin")
                    let phone = $(this).attr("data-phone")
                    let has_appointments = $(this).attr("data-has_appointments")

                    $("#car-model").attr("disabled", true)
                    
                    fetch(`/clients/brand-models/${brand_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            $(".spinner-border").addClass("d-none")

                            $("#car-model").html("")
                            $("#car-model").append("<option selected disabled>Selectionner le modèle</option>")
                            
                            $("#car-model").attr("disabled", false)
                            
                            jQuery.each(data, function (i, val) {
                                $("#car-model").append(`<option value='${val.id}'>${val.name}</option>`)
                            });
        
                            $("#car-brand").val(brand_id)
                            $("#car-model").val(model_id)


                            if (has_appointments == "true") {
                                //$("#btn-save-car").addClass("d-none")
                                $("#car-brand").attr("disabled", true)
                                $("#car-model").attr("disabled", true)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                            else {
                                //$("#btn-save-car").removeClass("d-none")
                                $("#car-brand").attr("disabled", false)
                                $("#car-model").attr("disabled", false)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                        })
                    });


                    $("#car-car_number").val(car_number)
                    $("#car-vin").val(vin)
                    $("#car-phone").val(phone)
                    
                    modal_car2.show()
                })
                    
            },
            initComplete: function(settings, data){
                to_export = data.data
            },
            "responsive": true,
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-completed').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-services option:selected").val()
                    e.workshop_id = $("#filter-workshops option:selected").val()
                    e.clients =  $("#completed_clients").prop("checked")
                    e.managers =  $("#completed_managers").prop("checked")
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service"},
                {"data": "workshop"},
                {"data": "date",
                    "render": function(data, display, record) {
                        return `${data}<br>${record.time}`
                    }
                },
                {"data": "created_at", 
                    "render": function(data, display, record) {
                        return moment(new Date(data)).locale("fr").utc().format('DD/MM/YYYY H:m')
                    }
                },
                {"data": "user_name"},
                {"data": "car_number", 
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-edit-car2' data-car_number='${record.car_number}' data-vin='${record.vin}' data-phone='${record.car_phone}' data-car_id='${record.car_id}' data-brand_id='${record.brand_id}' data-model_id='${record.model_id}'>${data}</a>`
                    }
                },
                {"data": "state"},
                {"data": "source", 
                    "render": function(data, display, record) {
                        let source = record.source

                        if (record.source == "Manager")
                            return source += `<br><span style='font-size: 12px;'>${record.source_name}</span>`
                        else
                            return source
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-appointment' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ],
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": true,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "pageLength": 10, 
            "bAutoWidth": false,
            'order' : [[3,'desc']]
        });  
        $(table_completed).parent().parent().removeClass("active").removeClass("show")
        $("#nav-completed-tab").on("click", function() {
            if ($("#btn-donwload-completed").length == 0) {

                $("#table-completed_filter").before(`<div style='display:inline'>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="completed_clients" id="completed_clients" checked>
                        <label class="form-check-label" for="completed_clients" style="font-style: italic; font-size: 14px;">
                            Clients
                        </label>
                    </div>
                    <div class="text-start" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="completed_managers" id="completed_managers" checked>
                        <label class="form-check-label" for="completed_managers" style="font-style: italic; font-size: 14px;">
                            Managers
                        </label>
                    </div>
                </div>`)

                $(document).on("click", "#completed_clients, #completed_managers", function() {
                    table_completed.ajax.reload()
                })
                
                $("#table-completed_filter").before(`<div style='display:inline'>
                    <button id='btn-donwload-completed' class='btn btn-success'><i class="fa fa-download"></i> Telecharger <img src='/assets/loader2.gif' class='d-none text-white' width='20'></button>
                    <input type='text' id='date-completed' placeholder='Date' class='form-control w-25' style='display: inline;' autocomplete='off'>
                </div>`)

                $(`#date-completed`).flatpickr({
                    mode: "range",
                    dateFormat: "d/m/Y",
                    allowInput: true,
                    autoClose: true,
                    locale: "fr"
                });

                $(document).on("click", "#btn-donwload-completed", function() {
                    $(this).attr("disabled", true)
                    $("#btn-donwload-completed img").removeClass("d-none")

                    download_completed()
                })
                
                
            }
        })
        

        table_canceled = $('#table-canceled').DataTable({
            initComplete: function() {

                $("#table-canceled_filter").before(`<div style='display:inline'>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="canceled_clients" id="canceled_clients" checked>
                        <label class="form-check-label" for="canceled_clients" style="font-style: italic; font-size: 14px;">
                            Clients
                        </label>
                    </div>
                    <div class="text-start" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="canceled_managers" id="canceled_managers" checked>
                        <label class="form-check-label" for="canceled_managers" style="font-style: italic; font-size: 14px;">
                            Managers
                        </label>
                    </div>
                </div>`)

                $(document).on("click", "#canceled_clients, #canceled_managers", function() {
                    table_canceled.ajax.reload()
                })
                    
                $(document).on("click", ".btn-edit-car2", function() {
                    $(".spinner-border").removeClass("d-none")

                    car_id = $(this).attr("data-car_id")
                    brand_id = $(this).attr("data-brand_id")
                    model_id = $(this).attr("data-model_id")
                    let car_number = $(this).attr("data-car_number")
                    let vin = $(this).attr("data-vin")
                    let phone = $(this).attr("data-phone")
                    let has_appointments = $(this).attr("data-has_appointments")

                    $("#car-model").attr("disabled", true)
                    
                    fetch(`/clients/brand-models/${brand_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            $(".spinner-border").addClass("d-none")

                            $("#car-model").html("")
                            $("#car-model").append("<option selected disabled>Selectionner le modèle</option>")
                            
                            $("#car-model").attr("disabled", false)
                            
                            jQuery.each(data, function (i, val) {
                                $("#car-model").append(`<option value='${val.id}'>${val.name}</option>`)
                            });
        
                            $("#car-brand").val(brand_id)
                            $("#car-model").val(model_id)


                            if (has_appointments == "true") {
                                //$("#btn-save-car").addClass("d-none")
                                $("#car-brand").attr("disabled", true)
                                $("#car-model").attr("disabled", true)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                            else {
                                //$("#btn-save-car").removeClass("d-none")
                                $("#car-brand").attr("disabled", false)
                                $("#car-model").attr("disabled", false)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                        })
                    });


                    $("#car-car_number").val(car_number)
                    $("#car-vin").val(vin)
                    $("#car-phone").val(phone)
                    
                    modal_car2.show()
                })
            },
            responsive: true,
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-canceled').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-services option:selected").val()
                    e.workshop_id = $("#filter-workshops option:selected").val()
                    e.clients =  $("#canceled_clients").prop("checked")
                    e.managers =  $("#canceled_managers").prop("checked")
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service"},
                {"data": "workshop"},
                {"data": "date",
                    "render": function(data, display, record) {
                        return `${data}<br>${record.time}`
                    }
                },
                {"data": "created_at", 
                    "render": function(data, display, record) {
                        return moment(new Date(data)).locale("fr").utc().format('DD/MM/YYYY H:m')
                    }
                },
                {"data": "user_name"},
                {"data": "car_number", 
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-edit-car2' data-car_number='${record.car_number}' data-vin='${record.vin}' data-phone='${record.car_phone}' data-car_id='${record.car_id}' data-brand_id='${record.brand_id}' data-model_id='${record.model_id}'>${data}</a>`
                    }
                },
                {"data": "state"},
                {"data": "source", 
                    "render": function(data, display, record) {
                        let source = record.source

                        if (record.source == "Manager")
                            return source += `<br><span style='font-size: 12px;'>${record.source_name}</span>`
                        else
                            return source
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-appointment' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ],
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": true,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "pageLength": 10,
            "bAutoWidth": false,
            'order' : [[3,'desc']]
        });
        $(table_canceled).parent().parent().removeClass("active").removeClass("show")

        table_rejected = $('#table-rejected').DataTable({
            initComplete: function() {

                $("#table-rejected_filter").before(`<div style='display:inline'>
                    <div class="text-start me-3" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="rejected_clients" id="rejected_clients" checked>
                        <label class="form-check-label" for="rejected_clients" style="font-style: italic; font-size: 14px;">
                            Clients
                        </label>
                    </div>
                    <div class="text-start" style='display:inline'>
                        <input class="form-check-input" type="checkbox" name="rejected_managers" id="rejected_managers" checked>
                        <label class="form-check-label" for="rejected_managers" style="font-style: italic; font-size: 14px;">
                            Managers
                        </label>
                    </div>
                </div>`)

                $(document).on("click", "#rejected_clients, #rejected_managers", function() {
                    table_rejected.ajax.reload()
                })
                   
                $(document).on("click", ".btn-edit-car2", function() {
                    $(".spinner-border").removeClass("d-none")

                    car_id = $(this).attr("data-car_id")
                    brand_id = $(this).attr("data-brand_id")
                    model_id = $(this).attr("data-model_id")
                    let car_number = $(this).attr("data-car_number")
                    let vin = $(this).attr("data-vin")
                    let phone = $(this).attr("data-phone")
                    let has_appointments = $(this).attr("data-has_appointments")

                    $("#car-model").attr("disabled", true)
                    
                    fetch(`/clients/brand-models/${brand_id}`, {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'default',
                    }).then(function(response) {
                        response.json().then(function(data) {
                            $(".spinner-border").addClass("d-none")

                            $("#car-model").html("")
                            $("#car-model").append("<option selected disabled>Selectionner le modèle</option>")
                            
                            $("#car-model").attr("disabled", false)
                            
                            jQuery.each(data, function (i, val) {
                                $("#car-model").append(`<option value='${val.id}'>${val.name}</option>`)
                            });
        
                            $("#car-brand").val(brand_id)
                            $("#car-model").val(model_id)


                            if (has_appointments == "true") {
                                //$("#btn-save-car").addClass("d-none")
                                $("#car-brand").attr("disabled", true)
                                $("#car-model").attr("disabled", true)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                            else {
                                //$("#btn-save-car").removeClass("d-none")
                                $("#car-brand").attr("disabled", false)
                                $("#car-model").attr("disabled", false)
                                $("#car-car_number").attr("disabled", false)
                                $("#car-vin").attr("disabled", false)
                            }
                        })
                    });


                    $("#car-car_number").val(car_number)
                    $("#car-vin").val(vin)
                    $("#car-phone").val(phone)
                    
                    modal_car2.show()
                })
            },
            responsive: true,
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-rejected').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-services option:selected").val()
                    e.workshop_id = $("#filter-workshops option:selected").val()
                    e.clients =  $("#rejected_clients").prop("checked")
                    e.managers =  $("#rejected_managers").prop("checked")
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service"},
                {"data": "workshop"},
                {"data": "date",
                    "render": function(data, display, record) {
                        return `${data}<br>${record.time}`
                    }
                },
                {"data": "created_at", 
                    "render": function(data, display, record) {
                        return moment(new Date(data)).locale("fr").utc().format('DD/MM/YYYY H:m')
                    }
                },
                {"data": "user_name"},
                {"data": "car_number", 
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-edit-car2' data-car_number='${record.car_number}' data-vin='${record.vin}' data-phone='${record.car_phone}' data-car_id='${record.car_id}' data-brand_id='${record.brand_id}' data-model_id='${record.model_id}'>${data}</a>`
                    }
                },
                {"data": "state"},
                {"data": "source", 
                    "render": function(data, display, record) {
                        let source = record.source

                        if (record.source == "Manager")
                            return source += `<br><span style='font-size: 12px;'>${record.source_name}</span>`
                        else
                            return source
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-appointment' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ],
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bPaginate": true,
            "bFilter": true,
            "bInfo": true,
            "bLengthChange": false,
            "searching": true,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "pageLength": 10,
            "bAutoWidth": false,
            'order' : [[3,'desc']]
        });

        $(table_rejected).parent().parent().removeClass("show").removeClass("active")

        table_client_rates = $('#table-client_rates').DataTable({
            "bPaginate": false,
            "bFilter": true,
            "bInfo": false,
            "bLengthChange": false,
            "searching": false,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bAutoWidth": false,
            'order' : [[1,'desc']]
        });
      
        table_rates = $('#table-rates').DataTable({
            "processing": true,
            "serverSide": true,
            "ajax": {
                "url": $('#table-rates').data('source'),
                data: function(e) {
                    e.service_id = $("#filter-rate_services").val()
                }
            },
            "pagingType": "full_numbers",
            "columns": [
                {"data": "service_name"},
                {"data": "stars",
                    "render": function(data, display, record) {
                        service_rater = null;
                        let el = document.createElement('div')
                        el.setAttribute("id", `service_rating-${record.id}`)
                        
                        service_rater = rater({element: el, rateCallback: function rateCallback(rating, done) {
                            service_rater.setRating(rating);
                            done();
                        }, 
                            starSize:32,
                            step: 0.5,
                            rating: parseFloat(record.stars),
                        });
                        service_rater.disable()

                        return  el.outerHTML
                    }
                },
                {"data": "id",
                    "render": function(data, display, record) {
                        return `<a href="javascript:void(0)" class='btn-see-rates' data-service_id='${record.id}' data-method='update' data-bs-effect="effect-scale" title="Voir"><i class="fa fa-eye" aria-hidden="true"></i></a>`
                    }
                }
            ],
            "columnDefs": [
                {"orderable": false, "targets": [0, 1, 2]}
            ],
            createdRow: function (row, data, index) {
                $(row).attr("data-element_id", data.id)
                if (document.querySelector(`#service_rating-${data.id}`) != null) {
                    
                   /* $(`#service_rating-${data.id}`).html("")
        
                    service_rater = null;
                    service_rater = rater({element: document.querySelector(`#service_rating-${data.id}`), rateCallback: function rateCallback(rating, done) {

                        service_rater.setRating(rating);
                        done();
                    }, 
                        starSize:32,
                        rating: parseInt(data.stars),
                    });

                    service_rater.disable()
                    $(`#service_rating-${data.id}`).html()*/
                }
            },
            "initComplete":function( settings, json){
           
               /* jQuery.each(json.data, function (i, val) {
                    service_rater = null;
                    service_rater = rater({element: document.querySelector(`#service_rating-${val.id}`), rateCallback: function rateCallback(rating, done) {

                        service_rater.setRating(rating);
                        done();
                    }, 
                        starSize:32,
                        rating: parseInt(val.stars),
                    });

                    service_rater.disable()
                })*/
            },
            language: {
                url: 'https://cdn.datatables.net/plug-ins/2.2.2/i18n/fr-FR.json',
            },
            "bPaginate": false,
            "bFilter": true,
            "bInfo": false,
            "bLengthChange": false,
            "searching": false,
            "destroy": true,
            "stateSave": false,
            "scrollCollapse": true,
            "bAutoWidth": false,
            'order' : [[1,'desc']]
        });


        $(".appointments-tables").on('click', ".btn-see-appointment", function(e) {
            appointment_id = $(e.currentTarget).parent().parent().data('element_id')
          
            fetch(`/appointments/${appointment_id}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        $(`.appointment-${$(e.currentTarget).data('appointment_id')} .indicator`).remove()
                        $(".appointment_creation").html("Créée le: <strong>" + moment(new Date(data.created_at)).locale("fr").utc().format('dddd DD MMM YYYY H:m') + "</strong>")
                        $('#see_appointment_id').val(data.id)
                        $("#see_workshop").val(data.workshop.name)
                        $("#see_service").val(`${data.service.name} (${data.duration} ${Pluralize( 'minute', data.duration )})`)
                        $("#see_date").val(moment(new Date(data.date)).locale("fr").format('dddd DD MMM YYYY'))
                        $("#see_periode").val(`${data.time} à ${ moment(new Date(`2024-08-27 ${data.time}`)).add(data.duration, "minutes").format("k:mm")}`);
                        //$("#see_periode").val(`${data.time} à ${parseInt(data.time.replace('h:00','')) + data.service.duration}h:00`);
                        $("#see_full_name").val(data.user.full_name)
                        $("#see_phone").val(data.phone)
                        $("#see_second_phone").val(data.second_phone)
                        $("#see_email").val(data.email);
                        $("#see_car_number").val(`${data.brand.brand} ${data.car.model.name} (${data.car.car_number})`);
                        $("#see_vin").val(`${data.car.vin}`);
                        $("#see_km").val(data.km);
                        $("#see_car_phone").val(data.car.phone)
                        $("#see_notes").val(data.notes);
                        $("#see_description").val(data.description);
                        $("#see_note_intern").val(data.note_intern);
                        $("#see_note_client").val(data.note_client);

                        if (data.state == "completed" || data.state == "rejected" || data.state == "canceled")
                            $("#see_state option").remove();
                        else {
                            $("#see_state option").remove();
                            $("#see_state").append(`<option value='accepted'>Accepté</option>`);
                            $("#see_state").append(`<option value='canceled'>Annulé</option>`);
                            $("#see_state").append(`<option value='rejected'>Rejeté</option>`);
                            $("#see_state").append(`<option value='completed'>Terminé</option>`);
                            $("#see_state").append(`<option value='pending'>En attente</option>`);
                            $("#see_state").append(`<option value='in_progress'>En cours d'entretien</option>`);
                            $("#see_state").append(`<option value='missed'>Client ne s'est pas présenté</option>`);
                        }

                        if (data.state == "completed") {
                            $("#see_state").append(`<option value='${data.state}'>Terminé</option>`);
                            $(".invoice_container").removeClass("d-none")
                            $("#see_invoice").val(data.invoice)
                        }
                        else {
                            $(".invoice_container").addClass("d-none")
                            $("#see_invoice").val("")
                        }

                        if (data.state == "canceled") 
                            $("#see_state").append(`<option value='${data.state}'>Annulé</option>`);
                        if (data.state == "rejected") 
                            $("#see_state").append(`<option value='${data.state}'>Rejeté</option>`);
                        

                        if (data.service.slug == 'carrosserie') {
                            $(".carrosserie").removeClass('visually-hidden')
                        }
                        else {
                            $(".carrosserie").addClass('visually-hidden')
                        }
                        $(`#see_state option[value='${data.state}']`).prop("selected", true)
                        
                        // rating
                        if (data.rating != null) {
                            
                            myRater = null
                            $("#rater").html("")

                            myRater = rater({element: document.querySelector("#rater"), rateCallback: function rateCallback(rating, done) {
                                myRater.setRating(rating);
                                done();
                            }, 
                                starSize:50,
                                step: 0.5,
                                rating: data.rating.star,
                            });

                            myRater.disable()

                            $("#nav-rating-tab").removeClass("d-none")

                            $("#rate_note").val(data.rating.note)
                        }
                        else {
                            $("#nav-rating-tab").addClass("d-none")
                        }

                        modal_appointment = new bootstrap.Modal(document.getElementById("modal-see_appointment"), {backdrop: 'static', keyboard: false});
                        modal_appointment.show()
                    })
                }
            })
        })

        $("#table-rates").on('click', ".btn-see-rates", function(e) {
            service_id = $(this).data('service_id')

            $(".service_name").text($(`#table-rates tr[data-element_id='${service_id}'] > td:first`).text())

            modal_rates = new bootstrap.Modal(document.getElementById("modal-see_rates"), {backdrop: 'static', keyboard: false});
            modal_rates.show()
            
            /*fetch(`/appointments/${appointment_id}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {

                    })
                }
            })*/
        })

        if ($("body").data("controller") == "calendar" ){
            getAppointments()
        }

        $("#btn-save_appointment").on('click', function(e) {
            appointment_id = $("#see_appointment_id").val()

            let formData = new FormData();
            formData.append('state', $("#see_state option:selected").val());
            formData.append('note_intern', $("#see_note_intern").val());
            formData.append('note_client', $("#see_note_client").val());
            formData.append('phone', $("#see_phone").val());

            let state = ""
            let invoice;

            if ($("#see_state option:selected").val() == "accepted")
                state = "Accepté?"
            if ($("#see_state option:selected").val() == "canceled")
                state = "Annulé?"
            if ($("#see_state option:selected").val() == "rejected")
                state = "Rejeté?"
            if ($("#see_state option:selected").val() == "completed") {
                state = "Terminé?"
                invoice = $("#see_invoice").val()
            }
            else {
                invoice = null
            }
            
            if ($("#see_state option:selected").val() == "pending")
                state = "En attente?"
            if ($("#see_state option:selected").val() == "in_progress") {
                state = "En cours d'entretien?"
            }

            formData.append('invoice', invoice);

            Swal.fire({
                title: state,
                text: "Voulez-vous vraiment valider?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Annuler',
                confirmButtonText: 'Oui',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return fetch(`/appointments/update-appointment/${appointment_id}`, {
                        method: 'PUT',
                        mode: 'cors',
                        cache: 'default',
                        body: formData,
                    }).then(function(response) {
                        if (response.ok) {

                            $("#btn-cancel-see_appointment").attr("disabled", true)
                            $("#btn-save_appointment").attr("disabled", true)
                            $("#btn-save_appointment .spinner-border ").removeClass("d-none")

                            response.json().then(function(data) {
                                Swal.fire({
                                    title: "Mis à jour !",
                                    icon: "success",
                                    text: `Réservation de ${data.brand.brand} ${data.car.model.name} ("${data.car.car_number})" à été mis à jour!`,
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonText: "Save",
                                    denyButtonText: `Don't save`
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                        //window.location.reload()
                                    }
                                });

                                table_inprogress.ajax.reload()
                                table_all.ajax.reload()
                                table_pending.ajax.reload()
                                table_accepted.ajax.reload()
                                table_canceled.ajax.reload()
                                table_rejected.ajax.reload()
                                table_completed.ajax.reload()
                                
                           
                                $("#btn-cancel-see_appointment").attr("disabled", false)
                                $("#btn-save_appointment").attr("disabled", false)
                                $("#btn-save_appointment .spinner-border ").addClass("d-none")
                                
                                // $("#modal-see_appointment").hide();
                                // $(".modal-backdrop.fade.show").remove()

                                $("#btn-cancel-see_appointment").trigger("click")

                                if (data.state == "completed") {
                                    state = "<span class='badge text-bg-success'>Fini</span>"

                                    $(`.rdv.appointment-${data.id} .badge`).remove()
                                    $(`.rdv.appointment-${data.id}`).prepend(state)
                                }
                                else if (data.state == "missed") {
                                    state = "<span class='badge text-bg-danger'>Client ne s'est pas présenté</span>"

                                    $(`.rdv.appointment-${data.id} .badge`).remove()
                                    $(`.rdv.appointment-${data.id}`).prepend(state)
                                }
                                else if (data.state == "rejected") {
                                    let parent = $(`.rdv.appointment-${data.id}`).parent().parent()

                                    $(`.rdv.appointment-${data.id}`).parent().remove()

                                    if ($(`.date_${data.date}_${parseInt(data.time.replace('h:00',''))}`).length == 0)  {
                                        $(`.table_${data.date}_${parseInt(data.time.replace('h:00',''))}`).remove()
                                    }
                                }

                                getAppointment()
                            })
                        }
                    })
                }
            })
        })

        $("#new-appoint-service").on("change", function() {
            getService($(this).val())
        })

        $(document).on("change", "#see_state", function() {
            if ($(this).val() == "completed")
                $(".invoice_container").removeClass("d-none")
            else
                $(".invoice_container").addClass("d-none")
        })
        
        function getAppointment() {

            let selected_service = $("#selected_service").val()
			let selected_workshop = $("#selected_workshop").val()

			if (selected_service == "")
				selected_service = $("#calendar-services option:first").val()
			if (selected_workshop == "")
				selected_workshop = $("#calendar-workshop option:first").val()

            if (selected_service == undefined || selected_workshop == undefined) {
                return
            }

            fetch(`/appointments/get-appointments/${selected_service}/${selected_workshop}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {

                        for(appointment of data) {
                            //$(`.appointment-${appointment.id} .state`).html(appointment.decorate_calendar_state)

                            $(`.appointment-${appointment.id}`).on("click", function(e) {
								fetch(`/appointments/${$(e.currentTarget).data('appointment_id')}`, {
									method: 'GET',
									mode: 'cors',
									cache: 'default',
								}).then(function(response) {
									if (response.ok) {
										response.json().then(function(data) {
                                           
											$(`.appointment-${$(e.currentTarget).data('appointment_id')} .indicator`).remove()
                                            
											$('#see_appointment_id').val(data.id)
											$("#see_service").val(`${data.service.name} (${data.service.duration} ${Pluralize( 'heure', data.service.duration )})`)
											$("#see_date").val(moment(data.date).locale("fr").format('dddd DD MMM YYYY'))
											$("#see_periode").val(`${data.time} à ${parseInt(data.time.replace('h:00','')) + data.service.duration}h:00`);
											$("#see_full_name").val(data.user.full_name)
											$("#see_phone").val(data.phone)
                                            $("#see_second_phone").val(data.second_phone)
											$("#see_email").val(data.email);
											$("#see_car_number").val(data.car.car_number);
                                            $("#see_vin").val(`${data.car.vin}`);
											$("#see_km").val(data.km);
											$("#see_notes").val(data.notes);
											$("#see_description").val(data.description);
											$("#see_note_intern").val(data.note_intern);
											$("#see_state").val(data.state);

                                            if (data.state == "completed")  {
                                                $(".invoice_container").removeClass("d-none")
                                                $("#see_invoice").val(data.invoice)
                                            }
                                            else {
                                                $(".invoice_container").addClass("d-none")
                                                $("#see_invoice").val("")
                                            }

											if (data.service.slug == 'carrosserie') {
												$(".carrosserie").removeClass('visually-hidden')
											}
											else {
												$(".carrosserie").addClass('visually-hidden')
											}
     
                                            modal_appointment = new bootstrap.Modal(document.getElementById("modal-see_appointment"), {backdrop: 'static', keyboard: false});
											modal_appointment.show()
										})
									}
								})
							})

                            //$(`.${appointment.date} .state`).html(appointment.decorate_calendar_state)
                            /*$(`.${appointment.date}`).html("")

							let color
							let new_appointment = ''

							if (appointment.service.slug == 'entretien-périodique')
								color = 'primary'
							else if (appointment.service.slug == 'diagnostic-mécanique')
								color = 'success'
							else if (appointment.service.slug == 'carrosserie')
								color = 'secondary'

							if (appointment.new)
								new_appointment = `<span class="indicator position-absolute start-0 translate-middle p-2 bg-danger border border-light rounded-circle"><span class="visually-hidden"></span></span>`

							$(`.${appointment.date}`).append(`<a href='javascript:' class='one-appointment -appointment-${appointment.id} position-relative' data-appointment_id='${appointment.id}'>
								<span class="badge text-bg-${color}" style='border: 1px solid white;'>${appointment.service.name} <br>
									${appointment.time} - ${parseInt(appointment.time.replace('h:00','')) + appointment.service.duration}h:00<br>
									(${appointment.user.full_name})
								</span>${new_appointment}
								${appointment.decorate_calendar_state}
								
								</a>`)
							$(`.${appointment.date}`).attr('data-appointment_id', appointment.id)

							$(`.appointment-${appointment.id}`).on("click", function(e) {
								fetch(`/appointments/${$(e.currentTarget).data('appointment_id')}`, {
									method: 'GET',
									mode: 'cors',
									cache: 'default',
								}).then(function(response) {
									if (response.ok) {
										response.json().then(function(data) {
                                           
											$(`.appointment-${$(e.currentTarget).data('appointment_id')} .indicator`).remove()
                                            
											$('#see_appointment_id').val(data.id)
											$("#see_service").val(`${data.service.name} (${data.service.duration} ${Pluralize( 'heure', data.service.duration )})`)
											$("#see_date").val(moment(data.date).locale("fr").format('dddd DD MMM YYYY'))
											$("#see_periode").val(`${data.time} à ${parseInt(data.time.replace('h:00','')) + data.service.duration}h:00`);
											$("#see_full_name").val(data.user.full_name)
											$("#see_phone").val(data.phone)
											$("#see_email").val(data.email);
											$("#see_car_number").val(data.car.car_number);
											$("#see_km").val(data.km);
											$("#see_notes").val(data.notes);
											$("#see_description").val(data.description);
											$("#see_note_intern").val(data.note_intern);
											$("#see_state").val(data.state);

											if (data.service.slug == 'carrosserie') {
												$(".carrosserie").removeClass('visually-hidden')
											}
											else {
												$(".carrosserie").addClass('visually-hidden')
											}
     
                                            //modal_appointment = new bootstrap.Modal(document.getElementById("modal-see_appointment"), {backdrop: 'static', keyboard: false});
											//modal_appointment.show()
										})
									}
								})
							})*/
						}
                    })
                }
            })
        }

        function getService(service_id) {
            let workshop_id = $("#new-appoint-workshop").val()
            let selected_date = $("#new-appoint-date").val()
            
            let url = `/workshops/services/${workshop_id}/${selected_date}`

            if (service_id != null) {
                url = `/workshops/services/${workshop_id}/${selected_date}/${service_id}`
            }

            fetch(`${url}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {

                        if (service_id != null) {
                            // let time = moment(new Date(`2024-09-02 ${data.times[0].morning_start.slice(0, -3)}`))
                            // let end = moment(new Date(`2024-09-02 ${data.times[0].morning_end.slice(0, -3)}`)).get('H')

                            $("#new-appoint-time").html(``)
                            
                            data.times.forEach(function(time) {
                                $("#new-appoint-time").append(`<option value='${time}'>${time}</option>`)
                            })

                            // data.
                            // $("#new-appoint-time").append(``)
                        }
                        else {
                            $("#new-appoint-service").html("")
                            data.services.forEach(function(service) {
                                $("#new-appoint-service").append(`<option value='${service.service.id}'>${service.service.name}</option>`)
                            })

                            getService($("#new-appoint-service option:selected").val())
                        }

                    })
                }
            })
        }
        
        //getService()
        
        $("#new-appoint-workshop").on("change", function() {
            workshop_id = $(this).val()

            $("#new-appoint-workshop").attr("disabled", true)
            $(".loader-workshops").removeClass("d-none")

            $("#new-appoint-services").attr("disabled", true)
            $(".loader-services").removeClass("d-none")
            
            let selected_date = $("#new-appoint-date").val()

            fetch(`/workshops/periode/${workshop_id}/${selected_date}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        $("#new-appoint-time").html("")
                        for(var i=0 ; i< data.times.length ; i++) {
                            $("#new-appoint-time").append(`<option value="${data.times[i]}">${data.times[i]}</option>`)
                        }
                        
                        $("#new-appoint-workshop").attr("disabled", false)
                        $(".loader-workshops").addClass("d-none")
                    })
                }
            })

            fetch(`/workshops/get_workshop_services/${workshop_id}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {

                        $("#new-appoint-service").html("")
                        jQuery.each(data.services, function (i, service) {
                            $("#new-appoint-service").append(`<option value="${service.service.id}">${service.service.name}</option>`)
                        })

                        $("#new-appoint-services").attr("disabled", false)
                        $(".loader-services").addClass("d-none")
                    })
                }
            })
        })

        $("#new-appoint-workshop").trigger("change")

        $("#filter-services").on("change", function() {
            table_all.ajax.reload()
            table_inprogress.ajax.reload()
            table_pending.ajax.reload()
            table_accepted.ajax.reload()
            table_canceled.ajax.reload()
            table_rejected.ajax.reload()
            table_completed.ajax.reload()
        })

        $("#filter-workshops").on("change", function() {
            table_all.ajax.reload()
            table_pending.ajax.reload()
            table_accepted.ajax.reload()
            table_canceled.ajax.reload()
            table_rejected.ajax.reload()
            table_completed.ajax.reload()
        })

        $("#filter-rate_services").on("change", function() {
            table_rates.ajax.reload()
        })


        $("#btn-save-appointment").on("click", function(event) {
            const forms = document.querySelectorAll('#modal-new_appointment .needs-validation')
            let isValid = true

            $(".error-appointement").addClass("visually-hidden")
            $(".error-appointement").text("")

            Array.prototype.slice.call(forms).forEach(function (form) {
                if (form.value == "") {
                    form.classList.add('is-invalid')
                    isValid = false
                    event.preventDefault()
                    event.stopPropagation()
                }

                form.classList.add('was-validated')
            }, false)

            if (isValid) {

                $("#btn-cancel-appointment").attr("disabled", true)
                $("#btn-save-appointment").attr("disabled", true)
                $("#btn-save-appointment").children().first().removeClass("d-none")

                let formData = new FormData();
                formData.append('user_id', $("#new-appoint-client_id").val());
                formData.append('km', $("#new_km").val());
                formData.append('car_id', $("#new-appoint-matricule").val());
                formData.append('note_intern', $("#new_notes").val());
                formData.append('workshop_id', $("#new-appoint-workshop").val())
                formData.append('service_id', $("#new-appoint-service").val())
                formData.append('date', $("#new-appoint-date").val())
                formData.append('time', $("#new-appoint-time").val())
                formData.append('phone', $("#new-appoint-phone").val())
                formData.append('second_phone', $("#new-appoint-second_phone").val())
                formData.append('email', $("#new-appoint-email").val())

                
                if ($("#new-appoint-phone").val() != $("#new-appoint-phone").attr("data-phone")) {
                    Swal.fire({
                        title: "Le numéro de téléphone a été changé",
                        text: "Voulez-vous confirmer?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Oui',
                        denyButtonText: "Annuler",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showLoaderOnConfirm: true,
                        showLoaderOnDeny: true,
                        showDenyButton: true,
                        showCancelButton: false,
                        preConfirm: () => {
                            formData.append('phone_changed', true)
                            fetch(`/appointments/create-appointment`, {
                                method: 'POST',
                                mode: 'cors',
                                cache: 'default',
                                body: formData,
                            }).then(function(response) {
                                if (response.ok) {
                                    response.json().then(function(data) {
                                        if (data.info != null) {
                                            $(".error-appointement").removeClass("visually-hidden")
                                            $(".error-appointement").text(data.info)

                                            $("#btn-cancel-appointment").attr("disabled", false)
                                            $("#btn-save-appointment").attr("disabled", false)
                                            $("#btn-save-appointment").children().first().addClass("d-none")
                                        }
                                        else {
                                            Swal.fire({
                                                title: "Mis à jour !",
                                                icon: "success",
                                                text: `Rendez-vous réservé!`,
                                                showDenyButton: false,
                                                showCancelButton: false,
                                              }).then((result) => {
                                                if (result.isConfirmed) {
                                                    window.location.reload()
                                                }
                                            });
                                        }
                                        
                                    })
                                }
                            })
                        },
                        preDeny: () => {
                            $("#btn-cancel-appointment").attr("disabled", false)
                            $("#btn-save-appointment").attr("disabled", false)
                            $("#btn-save-appointment").children().first().addClass("d-none")
                        }
                    })
                }
                else {
                    formData.append('phone_changed', false)
                    fetch(`/appointments/create-appointment`, {
                        method: 'POST',
                        mode: 'cors',
                        cache: 'default',
                        body: formData,
                    }).then(function(response) {
                        if (response.ok) {
                            response.json().then(function(data) {
                                if (data.info != null) {
                                    $(".error-appointement").removeClass("visually-hidden")
                                    $(".error-appointement").text(data.info)
    
                                    $("#btn-cancel-appointment").attr("disabled", false)
                                    $("#btn-save-appointment").attr("disabled", false)
                                    $("#btn-save-appointment").children().first().addClass("d-none")
                                }
                                else {
                                    Swal.fire({
                                        title: "Mis à jour !",
                                        icon: "success",
                                        text: `Rendez-vous réservé!`,
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        }).then((result) => {
                                        if (result.isConfirmed) {
                                            window.location.reload()
                                        }
                                    });
                                }
                                
                            })
                        }
                    })
                }
            }
        })

        $("#btn-new-car").on("click", function() {
            modal_new_car = new bootstrap.Modal(document.getElementById("modal-new_car"), {backdrop: 'static', keyboard: false});
            modal_new_car.show()
        })

        $("#btn-cancel-new_car").on("click", function() {
            modal_new_car.hide()
            $("#new_car_number").val("")
            $("#new_car_model").val("")
        })

        $("#btn-save-new_car").on("click", function() {
            const forms = document.querySelectorAll('#form-new_car')
            let isValid = true

            Array.prototype.slice.call(forms).forEach(function (form) {
                if (form.value == "") {
                    form.classList.add('is-invalid')
                    isValid = false
                    event.preventDefault()
                    event.stopPropagation()
                }

                form.classList.add('was-validated')
            }, false)

            if ($("#form-new_car").valid()) {
                $(".alert-zone").addClass("d-none")
                $(".alert-zone .alert").text("")

                $("#btn-cancel-new_car").attr("disabled", true)
                $(this).attr("disabled", true)
                $(this).children().first().removeClass("d-none")

                const formData = new FormData();
                formData.append('car_number', $("#new_car_number").val());
                formData.append('brand_model_id', $("#new_car_model option:selected").val());
                formData.append('model', $("#new_car_model option:selected").text());
                formData.append('vin', $("#new_vin").val());
                formData.append('user_id', $("#new-appoint-client_id").val());

                fetch(`/profile/create-car`, {
                    method: 'POST',
                    mode: 'cors',
                    cache: 'default',
                    body: formData,
                }).then(function(response) {
                    
                    if (response.ok) {
                        response.json().then(function(data) {
                          
                            modal_new_car.hide();
                            $("#btn-cancel-new_car").attr("disabled", false)
                            $("#btn-save-new_car").attr("disabled", false)
                            $("#btn-save-new_car").children().first().addClass("d-none")

                            $("#new-appoint-matricule").append(`<option value='${data.id}'>${data.model.name}(${data.car_number})</option>`)
                            
                            $("#new-appoint-matricule").val(data.id);

                            $("#new_car_number").val("")
                            $("#new_car_model").val("")
                            $("#new_brand").val("")
                            $("#new_vin").val("")
                        })
                    }
                    else {
                        response.json().then(function(data) {
                            $(".new_car_alert-zone").removeClass("d-none")
                            $(".new_car_alert-zone .alert").text(data.error.join(', '))

                            $("#btn-cancel-new_car").attr("disabled", false)
                            $("#btn-save-new_car").attr("disabled", false)
                            $("#btn-save-new_car .spinner-border ").addClass("d-none")

                            $(".alert-zone").removeClass("d-none")
                            $(".alert-zone .alert").text(data.error.join(', '))
                        })
                    }
                })

            }
        })

        $("#new_brand").on("click", function() {
            $(".spinner-border").removeClass("d-none")

            let brand_id = $(this).val()
            
            fetch(`/clients/brand-models/${brand_id}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                response.json().then(function(data) {
                    $(".spinner-border").addClass("d-none")
      
                    $("#new_car_model").html("")
                    $("#new_car_model").append("<option selected disabled>Selectionner le modèle</option>")

                    $("#new_car_model").attr("disabled", false)

                    jQuery.each(data, function (i, val) {
                        $("#new_car_model").append(`<option value='${val.id}'>${val.name}</option>`)
                    });
                })
            });
        })

        $("#btn-save-car").on("click", function() {
            if ($("#car-model").length > 0) {
                if ($("#car-model").val().trim() != "" && $("#car-car_number").val().trim() != "") {
                    $(".alert-zone").addClass("d-none")
                    $(".alert-zone .alert").text("")
                    
                    let formData = new FormData();
                    formData.append('brand_model_id', $("#car-model").val());
                    formData.append('model', $("#car-model option:selected").text());
                    formData.append('car_number', $("#car-car_number").val());
                    formData.append('phone', $("#car-phone").val());
                    formData.append('vin', $("#car-vin").val());
                    if ($("#car-phone").val().trim() != "")
                        formData.append('phone', $("#car-phone").val());
                    formData.append('user_id', $("#client_id").val());
    
                    $("#btn-cancel-car").attr("disabled", true)
                    $("#btn-save-car").attr("disabled", true)
                    $("#btn-save-car .spinner-border ").removeClass("d-none")
    
                    url = `/profile/update-car/${car_id}`
                    method = "PUT"
                    
                    fetch(`${url}`, {
                        method: method,
                        mode: 'cors',
                        cache: 'default',
                        body: formData,
                    }).then(function(response) {
                        if (response.ok) {
                            response.json().then(function(data) {
    
                                table_all.ajax.reload()
                                table_pending.ajax.reload() 
                                table_accepted.ajax.reload() 
                                table_inprogress.ajax.reload() 
                                table_completed.ajax.reload() 
                                table_canceled.ajax.reload() 
                                table_rejected.ajax.reload() 
    
                                $("#btn-cancel-car").attr("disabled", false)
                                $("#btn-save-car").attr("disabled", false)
                                $("#btn-save-car .spinner-border ").addClass("d-none")
    
                                //modal_car = new bootstrap.Modal(document.getElementById("modal-car"), {backdrop: 'static', keyboard: false});
                                modal_car.hide()
                            })
                        }
                        else {
                            response.json().then(function(data) {
    
                                $("#btn-cancel-car").attr("disabled", false)
                                $("#btn-save-car").attr("disabled", false)
                                $("#btn-save-car .spinner-border ").addClass("d-none")
    
                                $(".alert-zone").removeClass("d-none")
                                $(".alert-zone .alert").text(data.error.join(', '))
                            })
                        }
                    })
                }
            }
            else {
                let formData = new FormData();
                formData.append('car_number', $("#car-car_number").val());
                formData.append('phone', $("#car-phone").val());
                formData.append('vin', $("#car-vin").val());
                if ($("#car-phone").val().trim() != "")
                    formData.append('phone', $("#car-phone").val());
                formData.append('user_id', $("#client_id").val());

                $("#btn-cancel-car").attr("disabled", true)
                $("#btn-save-car").attr("disabled", true)
                $("#btn-save-car .spinner-border ").removeClass("d-none")

                url = `/profile/update-car/${car_id}`
                method = "PUT"
                
                fetch(`${url}`, {
                    method: method,
                    mode: 'cors',
                    cache: 'default',
                    body: formData,
                }).then(function(response) {
                    if (response.ok) {
                        response.json().then(function(data) {

                            table_all.ajax.reload()
                            table_pending.ajax.reload() 
                            table_accepted.ajax.reload() 
                            table_inprogress.ajax.reload() 
                            table_completed.ajax.reload() 
                            table_canceled.ajax.reload() 
                            table_rejected.ajax.reload() 

                            $("#btn-cancel-car").attr("disabled", false)
                            $("#btn-save-car").attr("disabled", false)
                            $("#btn-save-car .spinner-border ").addClass("d-none")

                            //modal_car = new bootstrap.Modal(document.getElementById("modal-car"), {backdrop: 'static', keyboard: false});
                            modal_car2.hide()
                        })
                    }
                    else {
                        response.json().then(function(data) {

                            $("#btn-cancel-car").attr("disabled", false)
                            $("#btn-save-car").attr("disabled", false)
                            $("#btn-save-car .spinner-border ").addClass("d-none")

                            $(".alert-zone").removeClass("d-none")
                            $(".alert-zone .alert").text(data.error.join(', '))
                        })
                    }
                })
            }
            
        })

        function getAppointments() {
            $('#myCalendar').LoadingOverlay("show")
            
            fetch(`/appointments/get-appointment-dates/${$("#selected_service").val()}`, {
                method: 'GET',
                mode: 'cors',
                cache: 'default',
            }).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {

                        let unavailableDates = data
                        $('#myCalendar').availabilityCalendar(unavailableDates, {locale: 'fr', defaultView: 'listMonth'})

                        $('#myCalendar').LoadingOverlay("hide")
                    })
                }
            })
        }

        if (document.getElementById("modal-new_appointment") != null) {
            document.getElementById("modal-new_appointment").addEventListener('hidden.bs.modal', function (event) {
                appointment_id = ""
                $("#list_clients").val("").trigger("change")
                $('#new_appointment_id').val("")
                $("#new_service").val("")
                $("#new_full_name").val("")
                $("#new_date").val("")
                $("#new_time").val("")
                $("#new_phone").val("")
                $("#new_email").val("");
                $("#new_car_number").val("")
                $("#new_km").val("")
                $("#new_notes").val("");
                $("#new_description").val("")
                $("#new_note_intern").val("")
                $('#new_note_client').val("")
            })
        }

        document.getElementById("modal-see_appointment").addEventListener('hidden.bs.modal', function (event) {
            appointment_id = ""
            $('#see_appointment_id').val("")
            $("#see_service").val("")
            $("#see_full_name").val("")
            $("#see_date").val("")
            $("#see_time").val("")
            $("#see_phone").val("")
            $("#see_second_phone").val("")
            $("#see_email").val("");
            $("#see_car_number").val("")
            $("#see_km").val("")
            $("#see_notes").val("");
            $("#see_description").val("")
            $("#see_note_intern").val("")
            $('#see_note_client').val("")
            $("#see_state").val('pending')

            $("#modal-see_appointment .nav-link").removeClass('active')
            $("#modal-see_appointment .tab-pane").removeClass('show active')
            $("#modal-see_appointment #nav-details-tab").addClass('active')
            $("#modal-see_appointment #nav-details").addClass('show active')

            $("#rate_note").val("")
        })

        if ($("#modal-see_rates").length > 0) {
            document.getElementById("modal-see_rates").addEventListener('hidden.bs.modal', function (event) {
                service_id = ""

                table_client_rates.rows().clear().draw();
            })

        }
            
  
        $("#toggle_calendar").on("click", function() {
            $("#myCalendar").removeClass("d-none")
            $("#myCalendarList").addClass("d-none")
        })
    }

    function download_completed() {

        let date_starts = moment(new Date(document.querySelector('#date-completed')._flatpickr.selectedDates[0])).format('YYYY-MM-DD')
        let date_ends = moment(new Date(document.querySelector('#date-completed')._flatpickr.selectedDates[1])).format('YYYY-MM-DD')
        

        let url = '/appointments/completed'
        if (date_starts != "Invalid date") {
            url += `/${date_starts}/${date_ends}`
        }

        fetch(`${url}`, {
            method: 'GET',
            mode: 'cors',
            cache: 'default',
        }).then(function(response) {
            if (response.ok) {
                response.json().then(function(data) {
                    to_export = data

                    let csv_data = [];
                    var csvrow = [];

                    $(".col_default span").each(function(index, element) {
                        csvrow.push($(element).text());
                    });

                    csvrow.push(`Service`);
                    csvrow.push(`Atelier`);
                    csvrow.push(`Date_RDV`);
                    csvrow.push(`Date`);
                    csvrow.push(`Client`);
                    csvrow.push(`Téléphone`);
                    csvrow.push(`Véhicule`);

                    csv_data.push(csvrow.join(","));

                    jQuery.each(to_export, function (i, val) {
                        var csvrow = [];

                        csvrow.push(`"${val['service'].name}"`);
                        csvrow.push(`"${val['workshop'].name}"`);
                        csvrow.push(`"${moment(new Date(val['date'])).format("DD/MM/YYYY")} ${val['time']}"`);
                        csvrow.push(`"${val['created_at']}"`);
                        csvrow.push(`"${val['user'].full_name}"`);
                        csvrow.push(`"${val['user'].phone}"`);
                        csvrow.push(`"${val['car'].car_number}"`);

                        csv_data.push(csvrow.join(";"));
                    })
                    
                    csv_data = csv_data.join('\n');
                    
                    downloadCSVFile(csv_data);
                })
            }
        })

    }

    function downloadCSVFile(csv_data) {

        // Create CSV file object and feed
        // our csv_data into it
        let CSVFile = new Blob([csv_data], {
            type: "text/csv"
        });

        // Create to temporary link to initiate
        // download process
        var temp_link = document.createElement('a');

        // Download csv file
        let date = moment(new Date()).format("DD_MM_YYYY_HH:mm")

        temp_link.download = `SAV_RENDEZ-VOUS-TERMINES_${date}.csv`;
        var url = window.URL.createObjectURL(CSVFile);
        temp_link.href = url;

        // This link should not be displayed
        temp_link.style.display = "none";
        document.body.appendChild(temp_link);

        // Automatically click the link to
        // trigger download
        temp_link.click();
        document.body.removeChild(temp_link);

        $(".export-loader").addClass("d-none")
        $("#btn-donwload-completed").attr("disabled", false)
        $("#btn-donwload-completed img").addClass("d-none")
    }
})